// firebase
import { db } from "config/firebase";
import { doc, setDoc } from "firebase/firestore";

// A ---------------------------------------------------------------------- M

const createDataBox = async (tagID, uid, name, description, tipologiaDocumentale) => {
  try {
    const tagRef = doc(db, "tagsdata", tagID);

    const dataBox = {
      owner_uuid: uid,
      name,
      description,
      types: [],
      followers: [],
      ...(tipologiaDocumentale && { tipologiaDocumentale }),
    };

    await setDoc(tagRef, dataBox);
  } catch (error) {
    console.error(`Error in createDataBox for databox ${tagID} and user ${uid}:`, error);
  }
};

export default createDataBox;
